module.exports = new __parcel__URL__("postBG_blob.715008d7.webp").toString();